import React, { useEffect, useState, useRef } from 'react';
import { GoogleMap, useLoadScript, Autocomplete, Marker } from '@react-google-maps/api';
import { InputAdornment, TextField } from "@mui/material";
import config from "../../config.json";
import { useTranslation } from 'react-i18next';
const containerStyle = {
  height: '520px',
  margin: "0px 40px",
  borderRadius: '20px',
  border: '1px solid #000000',
};

const inputStyles = {
  position: "absolute",
  top: "20px",
  left: "20px",
  zIndex: 1
};

const defaultCenter = {
  lat: 13.198909,
  lng: 77.706893
  
};

// Only load the libraries we need
const libraries = ["places"];

export default function StopAddMap({
  initialLatitude,
  initialLongitude,
  onPositionChange
}) {
  const {t} = useTranslation();
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: config.googleMapsApiKey ,
    libraries,
});

  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(defaultCenter);
  const [marker, setMarker] = useState(null);
  const autoCompleteRef = useRef(null);

  useEffect(() => {
    if (initialLatitude && initialLongitude) {
      const newPosition = {
        lat: parseFloat(initialLatitude),
        lng: parseFloat(initialLongitude)
      };
      setCenter(newPosition);
      setMarker(newPosition);
      if (map) {
        map.panTo(newPosition);
        map.setZoom(15);
      }
    }
  }, [initialLatitude, initialLongitude, map]);

  const onLoad = React.useCallback(function callback(map) {
    if (initialLatitude && initialLongitude) {
      const initialPosition = {
        lat: parseFloat(initialLatitude),
        lng: parseFloat(initialLongitude)
      };
      map.panTo(initialPosition);
    } else {
      // Only set bounds if we don't have initial coordinates
      const bounds = new window.google.maps.LatLngBounds(center);
      map.fitBounds(bounds);
    }
    setMap(map);
  }, [center, initialLatitude, initialLongitude]);

  const onUnmount = React.useCallback(function callback() {
    setMap(null);
  }, []);

  const handlePlaceSelect = () => {
    try {
      if (autoCompleteRef.current) {
        const place = autoCompleteRef.current.getPlace();
        if (place && place.geometry && place.geometry.location) {
          const newPosition = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };
          updatePosition(newPosition);
        } else {
          console.warn("Selected place doesn't have valid geometry");
        }
      }
    } catch (error) {
      console.error("Error selecting place:", error);
    }
  };

  const handleMapClick = (event) => {
    const newPosition = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    };
    updatePosition(newPosition);
  };

  const updatePosition = (position) => {
    setCenter(position);
    setMarker(position);
    if (map) {
      map.panTo(position);
      map.setZoom(15);
    }
    onPositionChange(position.lat, position.lng);
  };

  if (loadError) return <div>Error loading maps: {loadError.message}</div>;
  if (!isLoaded) return <div>Loading maps...</div>;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={15}
      onLoad={onLoad}
      onUnmount={onUnmount}
      onClick={handleMapClick}
    >
      <div style={inputStyles}>
        <Autocomplete
          onLoad={(autoComplete) => {
            autoCompleteRef.current = autoComplete;
          }}
          onPlaceChanged={handlePlaceSelect}
        >
          <div className="search-filter-wrapper search_container" style={{
            position: 'absolute', 
            zIndex: 1000, 
            backgroundColor: "transparent"
          }}>
            <TextField
              size="small"
              id="search"
              sx={{backgroundColor:"white"}}
              label={t("search")}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#000000"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-search"
                      style={{ cursor: 'pointer', marginLeft: '5px' }}
                    >
                      <circle cx="11" cy="11" r="8"></circle>
                      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: {
                  border: "none",
                },
              }}
            />
          </div>
        </Autocomplete>
      </div>

      {marker && <Marker position={marker} />}
    </GoogleMap>
  );
}